<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    submitTitle="Complete"
    :submitting="submitting"
    :icon="icon"
    closeTitle="Cancel"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <div>
      <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
        <div v-if="isOrderDespatchType">
          <NotificationBar type="warning">
            <NotificationBarTitle>This will complete the task item, mark items as despatched and invoice despatched items</NotificationBarTitle>
          </NotificationBar>

          <FormRow label="Despatch Items">
            <FormOption label="Only Scanned Items" name="optionScannedInOnly" setting="true" v-model="optionScannedInOnly" />
            <FormOption label="All Items" name="optionScannedInOnly" setting="false" v-model="optionScannedInOnly" />
          </FormRow>
        </div>

        <div v-if="isTransferType">
          <NotificationBar type="warning">
            <NotificationBarTitle>This will complete the task item and mark items as transferred</NotificationBarTitle>
          </NotificationBar>

          <FormRow label="Transfer Items">
            <FormOption label="Only Scanned Items" name="optionScannedInOnly" setting="true" v-model="optionScannedInOnly" />
            <FormOption label="All Items" name="optionScannedInOnly" setting="false" v-model="optionScannedInOnly" />
          </FormRow>
        </div>

        <div v-if="!isOrderDespatchType && !isTransferType">
          <NotificationBar type="info">
            <NotificationBarTitle>This will complete the task item. Any linked order items will not be despatched or invoiced</NotificationBarTitle>
          </NotificationBar>
        </div>
        
      </FormGroup>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { TaskItemTypes, TaskSignoffTypes } from '@/store/types'

export default {
  name: 'TaskItemCompleteDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    taskId: Number,
    taskItemId: Number,
    task: Object
  },
  data() {
    return {
      dialogForm: {},
      optionScannedInOnly: 'true',
      submitting: false
    }
  },
  computed: {
    title() {
      if(this.isOrderDespatchType)
        return 'Despatch Task Item'
      return 'Complete Task Item'
    },
    icon() {
      if(this.isOrderDespatchType)
        return 'fa-truck'
      return 'fa-check-circle'
    },
    forceScanIn() {
      return this.optionScannedInOnly != 'true'
    },
    taskItem() {
      if(this.task && this.task.taskItems)
        return this.task.taskItems.find(taskItem => taskItem.id == this.taskItemId)

      return null
    },
    isTransferType() {
      if(this.taskItem)
        return this.taskItem.type == TaskItemTypes.transferInternal || this.taskItem.type == TaskItemTypes.transferExternal
      return false
    },
    isOrderDespatchType() {
      if(this.taskItem)
        return this.taskItem.type == TaskItemTypes.orderDespatch
      return false
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    show() {
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var confirmTitle = 'Complete Task Item?'
      var confirmMessage = 'This will flag the task item as completed'
      
      if(this.isOrderDespatchType) {
        confirmTitle = 'Despatch Task Item?'
        confirmMessage = 'This will despatch and invoice only order items that were scanned in for this task item'
        if(this.forceScanIn)
          confirmMessage = 'This will despatch and invoice <strong>ALL</strong> order items associated with this task item'
      }
      if(this.isTransferType) {
        confirmTitle = 'Complete Task Item?'
        confirmMessage = 'This will transfer only items that were scanned in for this task item'
        if(this.forceScanIn)
          confirmMessage = 'This will transfer <strong>ALL</strong> items associated with this task item'
      }

      this.confirmMessage(confirmTitle, '', { html: confirmMessage })
      .then(confirm => {
        if(confirm) {
          this.submitting = true

          let completeData = {
            contactSignoffType: TaskSignoffTypes.none,
            forceScanIn: this.forceScanIn,
            forceScanOut: true
          }

          this.$apiService.tasksService.completeTaskItem(this.taskId, this.taskItemId, completeData)
          .then(response => {
            this.modalClosed(true)
            this.hide()
          })
          .catch(err => {
            this.dialogForm = this.processFormResponse(err)
          })
          .finally(() => {
            this.submitting = false
          })
        }
      })
    },
  }
}
</script>